/**
 * Design Tokens for Z Modular Theme
 * 
 * Extends the base avenue theme tokens with Z Modular branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-avenue/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Z Modular brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Z Modular brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Z Modular typography - customize these
    // heading: '"Your Heading Font", serif',
    body: "'Work Sans', sans-serif",
  },
};

export default tokens;
